import { render, staticRenderFns } from "./DiagStlmt.vue?vue&type=template&id=2383736c"
import script from "./DiagStlmt.vue?vue&type=script&lang=js"
export * from "./DiagStlmt.vue?vue&type=script&lang=js"
import style0 from "./DiagStlmt.vue?vue&type=style&index=0&id=2383736c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2383736c')) {
      api.createRecord('2383736c', component.options)
    } else {
      api.reload('2383736c', component.options)
    }
    module.hot.accept("./DiagStlmt.vue?vue&type=template&id=2383736c", function () {
      api.rerender('2383736c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/settlement/DiagStlmt.vue"
export default component.exports